module.exports = __webpack_public_path__ + "static/media/Tucuman.5ccfdd4f.svg";